export enum ThemeType {
  Dark = 'dark',
  LightModern = 'light-modern',
  FiordNight = 'fiord-night',
}
